import WorkOrderList from "../../work_order/work_order_list";

const TASKS_CONFIG = {
  pageTitle: "Tasks",
  documentTitle: "Tasks - RueBaRue",
  showCreateButton: false,
  showFilters: false,
  showCSVExport: false,
  showTags: false,
  showDelete: false,
  showEdit: "owner_only", // only owners can edit; assignees see comment only
  urlSync: false,
  fetchTags: false,
  extraCriteria: { my_tasks: "true" },
};

const Tasks = () => <WorkOrderList config={TASKS_CONFIG} />;

export default Tasks;
